// extracted by mini-css-extract-plugin
export default {"avatarWrapper":"styles_avatarWrapper__PgbM1","userName":"styles_userName__fSRns","plan":"styles_plan__UEvJs","menu":"styles_menu__6ka7I","logoutButton":"styles_logoutButton__ancSq"};